export default __webpack_public_path__ + "media/fonts/fonts_header_icons.woff";